import React from 'react'
import DynamicColor from '../common/dynamic-color'
import { COLOR_NAME } from '../../constants'
import { useTranslation } from 'react-i18next'

const Textarea = React.forwardRef(
    (
        {
            className = '',
            i18nDataError,
            value = '',
            label,
            error,
            inputStyle,
            required,
            ...props
        },
        ref
    ) => {
        const { t } = useTranslation()
        const classes = ['app-textarea', error ? 'error' : '', className].join(
            ' '
        )

        return (
            <div className={classes}>
                {label && (
                    <DynamicColor
                        style={{ color: COLOR_NAME.BODY_TEXT }}
                        className="app-textarea__label"
                    >
                        {label}
                        {required && (
                            <span className="ml-1 app-input__required">
                                (*)
                            </span>
                        )}
                    </DynamicColor>
                )}

                <DynamicColor
                    tag="textarea"
                    {...props}
                    ref={ref}
                    style={{
                        color: COLOR_NAME.INPUT_TEXT,
                        backgroundColor: COLOR_NAME.INPUT_BG,
                        borderColor: COLOR_NAME.INPUT_LINE,
                        ...inputStyle,
                    }}
                    value={value}
                />

                {error && (
                    <div className="app-textarea__error mt-2">
                        {t(error, { ...i18nDataError })}
                    </div>
                )}
            </div>
        )
    }
)

export default Textarea
